import { defineRecipe } from '@chakra-ui/react';

export const inputAddon = defineRecipe({
  className: 'chakra-input-addon',
  variants: {
    variant: {
      outline: {
        borderWidth: '1px',
        borderColor: 'gray.400',
        bg: 'bg.muted',
        paddingX: 4,
        fontSize: 'md',
        borderRadius: 'md',
      },
    },
  },
});
